// @flow
import React from 'react';
import {
  compose,
  withProps,
  setDisplayName,
} from 'recompose';
import reactCSS from 'reactcss';
import { getStyles } from '@ux/style-utils';
import { gu2px } from '@ux/theme-utils';
import * as r from 'ramda';
import { createPaintbrushUrl } from '@ux/glyphs';

const stylesheet = ({
  theme,
}) => {
  const {
    spacing,
  } = theme;

  return {
    default: {
      root: {
        width: 24,
        height: 24,
        padding: gu2px(0.5, spacing),
        display: 'inline-block',
        verticalAlign: 'middle',
        lineHeight: 1,
      },
      icon: {
        maxWidth: '100%',
        display: 'block',
      },
    },
  };
};

const stylesheetToStyles = r.unary(reactCSS);

const PureDomainIcon = ({
  fill,
  styles,
  icon,
  alt,
}) => (
  <span style={styles.root}>
    <img
      style={styles.icon}
      src={createPaintbrushUrl(icon, [ fill ])}
      alt={alt}
    />
  </span>
);

export const enhance = compose(
  setDisplayName('DomainIcon'),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureDomainIcon);
